import { useState, useCallback, useEffect } from "react";

const GLOBAL_KEY = "mo_platform_tour_global";

export const usePlatformTour = (pageKey: string, enabled: boolean = true) => {
  const isFirstVisitEver = (() => {
    try {
      return !localStorage.getItem(GLOBAL_KEY);
    } catch {
      return false;
    }
  })();

  const [showTour, setShowTour] = useState(() => {
    // Only auto-start on Home page AND only on the very first platform visit
    return enabled && pageKey === "home" && isFirstVisitEver;
  });

  const startTour = useCallback(() => setShowTour(true), []);

  const endTour = useCallback(() => {
    setShowTour(false);
    try {
      localStorage.setItem(GLOBAL_KEY, "true");
    } catch {}
  }, []);

  return { showTour, startTour, endTour };
};
